import { Controls } from '../controls';
import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';

const _Clone = <T>(from: T): T => {
  return cloneDeep<T>(from);
};

const _Merge = <K extends T1 & T2, T1 = {}, T2 = {}>(fromMain: T1, from: T2): K => {
  return merge<K, T2, T1>({} as K, from, fromMain);
};

const _ArraySum = <T>(input: T[] | null | undefined, property?: keyof T): number => {
  if (input === null || input === undefined) return 0;
  if (property) return input.reduce((a: number, b: T) => a + Number(b[property] || 0), 0);
  return input.reduce((a: number, b: T) => a + Number(b || 0), 0);
};

const _ArrayDistinct = <T>(input: T[] | null | undefined): T[] => {
  if (input === null || input === undefined) return [];
  if (Controls.IsArray(input)) return input.filter((i, v, j) => j.indexOf(i) === v);
  return [];
};

const _ArraySort = <T>(input: T[] | null | undefined): T[] => {
  if (input === null || input === undefined) return [];
  if (Controls.IsArray(input)) return input.sort();
  return [];
};

const _ArraySortBy = <T>(input: T[] | null | undefined, property: string): T[] => {
  if (input === null || input === undefined) return [];
  if (Controls.IsArray(input) && input[0] && (input[0] as any)[property]) {
    return input.sort((i1, i2) =>
      (i1 as any)[property].toString().localeCompare((i2 as any)[property].toString())
    );
  }
  return [];
};

const _ArrayDistinctBy = <T>(input: T[] | null | undefined, property: string): T[] => {
  if (input === null || input === undefined) return [];
  if (Controls.IsArray(input) && input[0] && (input[0] as any)[property]) {
    return input.filter(
      (i1, v, j) => j.findIndex((i2) => (i1 as any)[property] === (i2 as any)[property]) === v
    );
  }
  return [];
};

const _ArrayDistinctWithExpression = <T>(
  input: T[] | null | undefined,
  func: (i: T) => string
): T[] => {
  if (input === null || input === undefined) return [];
  if (Controls.IsArray(input) && input[0] && Controls.IsFunction(func)) {
    let hashTable = Object.create(null);
    return input.filter((i) => {
      return hashTable[func(i)] ? false : (hashTable[func(i)] = true);
    });
  }
  return [];
};

export const Operation = {
  Clone: _Clone,
  Merge: _Merge,
  ArraySum: _ArraySum,
  ArraySort: _ArraySort,
  ArraySortBy: _ArraySortBy,
  ArrayDistinct: _ArrayDistinct,
  ArrayDistinctBy: _ArrayDistinctBy,
  ArrayDistinctWithExpression: _ArrayDistinctWithExpression,
};
